import { render, staticRenderFns } from "./ItemMealCard.vue?vue&type=template&id=5b523938&scoped=true&"
import script from "./ItemMealCard.vue?vue&type=script&lang=js&"
export * from "./ItemMealCard.vue?vue&type=script&lang=js&"
import style0 from "./ItemMealCard.vue?vue&type=style&index=0&id=5b523938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b523938",
  null
  
)

export default component.exports